import 'regenerator-runtime/runtime'
import React, { useRef, useState } from 'react'
import CommissionAdminContext from './CommissionAdminContext'
import {
  CommissionAdminValues,
  AppProviderProps,
  CommissionValues,
  FetchResponse,
  ToastOptions
} from '../types'
import Commission from '../components/Commission/Commission'
import { EventEmitter } from 'events'

const CommissionAdminProvider = ({ children }: AppProviderProps): JSX.Element => {
  const [commissionFile, setCommissionFile] = useState<File | null>(null)
  const [commissionResponse, setCommissionResponse] = useState<Commission[] | undefined>(undefined)
  const [isUnauthorized, setIsUnauthorized] = useState<boolean>(false)
  const eventEmitterRef = useRef<EventEmitter>()
  if (!eventEmitterRef.current) {
    eventEmitterRef.current = new EventEmitter()
  }
  const eventEmitter = eventEmitterRef.current

  const handleClearInputFile = () => {
    console.log('Clearing commission file')
    setCommissionFile(null)
  }

  const handleFileUpload = (file: File) => {
    console.log('File Charged')
    setCommissionFile(file)
  }

  const handleSetToastOptions = (data: FetchResponse) => {
    const opt: ToastOptions = {
      message: data.message,
      type: data.status === 200 ? 'success' : 'warning',
      contentStyle: { textAlign: "center", alignContent: "center", alignItems: "center", alignSelf: "center", fontSize: "18px", minWidth: "500px", minHeight: "35px" },
      dismissible: true,
      duration: 4000
    }
    console.log('emitting SHOW_TOAST');
    eventEmitter.emit('SHOW_TOAST', opt);
  }

  const handleAuthorization = () => setIsUnauthorized(!isUnauthorized)

  const handleCommissionResponse = (data: Commission[]) => setCommissionResponse(data)

  const commissionValues: CommissionValues = {
    commissionFile,
    handleClearInputFile,
    handleFileUpload,
    handleSetToastOptions,
    commissionResponse,
    handleCommissionResponse
  }

  const value: CommissionAdminValues = {
    isUnauthorized,
    handleAuthorization,
    commissionValues,
    eventEmitter,
  }

  return (
    <CommissionAdminContext.Provider value={value}>
      {children}
    </CommissionAdminContext.Provider>
  )
}

export default CommissionAdminProvider
